export default "__VITE_ASSET__Bnr60E8K__"